module.exports = __webpack_public_path__ + "static/media/bombas-pe-02.c783a5cf.jpg";